import { useQuery } from '@tanstack/react-query';
import type { PriceListApiResponse } from '../types';
import { QK_GET_PRICE_LIST } from './use-price-lists';
import { usePriceListsApi } from './use-price-lists-api';

export function usePriceList(slug: string, options?: { enabled?: boolean }) {
  const { priceListsApi } = usePriceListsApi();

  return useQuery<PriceListApiResponse>({
    queryKey: QK_GET_PRICE_LIST(slug),
    queryFn: () => priceListsApi.priceList(slug).get(),
    enabled: options?.enabled,
  });
}
